/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{nativeArrayMaxSize as r}from"../../core/typedArrayUtil.js";function t(t){return Array.isArray(t)?t.length<r?t:new Uint16Array(t):t.length<r?Array.from(t):t}export{t as compactUShortArray};
